import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionSummary, Box, AccordionDetails } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useBulkActionSummaryValue } from "./BulkSummaryStepSummaryValue.js";
const useStyles = makeStyles()((theme) => ({
  bulkActionSummary: {
    width: "100%",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  bulkActionSummaryHeader: {
    padding: 0,
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
    display: "flex"
  },
  bulkActionSummaryHeaderNoBorder: {
    borderBottom: "0"
  },
  bulkActionSummaryContent: {
    padding: theme.spacing(2, 0),
    display: "flex",
    width: "100%"
  },
  bulkActionSummaryHeaderActionLabel: {
    display: "flex",
    width: theme.spacing(20),
    minWidth: theme.spacing(25),
    maxWidth: theme.spacing(25),
    alignItems: "center",
    columnGap: theme.spacing(1.5)
  },
  bulkActionSummaryHeaderActionValue: {
    display: "flex",
    overflow: "auto",
    maxWidth: theme.custom.bulkSummaryDetailsItemValueWidth
  },
  bulkActionSummaryHeaderActionMeta: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    columnGap: theme.spacing(1)
  },
  bulkActionSummaryDetails: {
    padding: 0,
    display: "flex",
    flexDirection: "column"
  },
  bulkActionSummaryDetailsSmall: {
    height: "200px",
    overflowY: "auto"
  }
}));
const BulkActionSummaryDetailsInfo = ({
  actionKey,
  actionValue,
  actionLabel,
  children,
  actionTotal,
  expandable,
  size = "normal"
}) => {
  const { classes } = useStyles();
  const actionSummary = useBulkActionSummaryValue({ actionKey, actionValue });
  return /* @__PURE__ */ React.createElement(Accordion, { className: classes.bulkActionSummary, expanded: !expandable ? true : void 0, key: `actionSummary-${actionKey}` }, /* @__PURE__ */ React.createElement(AccordionSummary, { className: classes.bulkActionSummaryHeader, expandIcon: expandable ? /* @__PURE__ */ React.createElement(ExpandMore, null) : null }, /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionLabel }, actionLabel), /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionValue }, actionSummary ? actionSummary : null), /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionMeta }, actionTotal)), /* @__PURE__ */ React.createElement(
    AccordionDetails,
    {
      className: `${classes.bulkActionSummaryDetails} ${size === "small" ? classes.bulkActionSummaryDetailsSmall : ""}`
    },
    children
  ));
};
const BulkActionSummaryDetailsInfoNotExpandable = ({
  actionKey,
  actionValue,
  actionLabel,
  children,
  actionTotal
}) => {
  const { classes } = useStyles();
  const actionSummary = useBulkActionSummaryValue({ actionKey, actionValue });
  return /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummary }, /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeader }, /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryContent }, /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionLabel }, " ", actionLabel), /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionValue }, actionSummary ? actionSummary : null), /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionMeta }, actionTotal))), children);
};
const BulkActionSummaryDetailsInfoExpanded = ({
  actionLabel,
  children,
  actionTotal,
  size = "normal"
}) => {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummary }, /* @__PURE__ */ React.createElement(Box, { className: `${classes.bulkActionSummaryHeader} ${classes.bulkActionSummaryHeaderNoBorder}` }, /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryContent }, /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionLabel }, actionLabel), /* @__PURE__ */ React.createElement(Box, { className: classes.bulkActionSummaryHeaderActionMeta }, actionTotal))), /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(
        {
          [classes.bulkActionSummaryDetailsSmall]: size === "small"
        },
        classes.bulkActionSummaryDetails
      )
    },
    children
  ));
};
export {
  BulkActionSummaryDetailsInfo,
  BulkActionSummaryDetailsInfoExpanded,
  BulkActionSummaryDetailsInfoNotExpandable
};
//# sourceMappingURL=BulkSummaryStepActionItem.js.map
